<!-- Export Button -->


<!-- PDF Pages for Export -->
<div style="position: absolute; left: -9999px; top: -9999px;"  class="pdf-page-wrapper">
  <div id="pdf-page-1" class="pdf-page-store-details">
    <!-- Header Section -->
    <div class="pdf-header">
      <div class="pdf-header-inner">
        <div class="pdf-header-content">
          <!-- Logo Placeholder - User will add logo -->
          <img height="37" src="assets/images/rs_logo_blue_white_inline_transparent_cropped.png" alt="">

          <div class="pdf-address">{{ location || formData?.location || 'Location not provided' }}</div>
          <div class="pdf-generated-date">Generated: {{ getCurrentDate() }}</div>
        </div>
      </div>
    </div>
    
    <!-- Pattern line after header -->
    <div class="pdf-pattern-line-top">
      <div class="pdf-pattern-segment"></div>
      <div class="pdf-pattern-segment"></div>
    </div>

    <!-- Main Content -->
    <div class="pdf-main-content">
      <h1 class="pdf-page-title">Store Details entered to Project Sales</h1>

      <!-- Store Information -->
      <div class="pdf-store-info">
        <div class="pdf-grocer-name">
          <span class="pdf-label">Grocer's Name :</span>
          <span class="pdf-value"> {{ getGrocerName() }} </span>
        </div>

        <div class="pdf-sqft-section">
          <div class="pdf-sqft-value">
            <span class="pdf-label">SQFT Value :</span>
            <span class="pdf-value"> {{ formatNumber(formData?.sqft) || '--' }} </span>
          </div>
          <div class="pdf-sqft-description">
            <span class="pdf-description-text">{{ getSqftWarningText() }}</span>
          </div>
        </div>
      </div>

      <!-- Summary Section -->
      <div class="pdf-summary-section">
        <div class="pdf-summary-header">
          <div class="pdf-summary-title">Summary Section</div>
        </div>

        <div class="pdf-summary-grid">
          <!-- First Row -->
          <div class="pdf-summary-row">
            <div class="pdf-summary-cell">
              <div class="pdf-cell-label">Projected Weekly Sales Range (In $) </div>
              <div class="pdf-cell-value">{{ getWeeklySalesRange() }}</div>
            </div>
            <div class="pdf-summary-cell">
              <div class="pdf-cell-label">Total Sales Projection</div>
              <div class="pdf-cell-value">{{ summaryData?.totalSalesProjectionStatus || '--' }}</div>
              <small *ngIf="!bannerCBSAAverages?.cbsa && summaryData?.totalSalesProjectionStatus !== '--'" class="pdf-cell-sublabel">
                {{ 'SUMMARY_SECTION.RELATIVE_OVERALL_AVG' | translate }}
              </small>
              <small *ngIf="bannerCBSAAverages?.cbsa" class="pdf-cell-sublabel">
                {{ 'SUMMARY_SECTION.OUT_OF' | translate:{name: bannerCBSAAverages?.name, state: getStateAbbreviation(cbsaName)} }}
              </small>
            </div>
            <div class="pdf-summary-cell pdf-summary-cell-last">
              <div class="pdf-cell-label">Sales Per SQFT Projection</div>
              <div class="pdf-cell-value">{{ summaryData?.sqftProjectionStatus || '--' }}</div>
              <small *ngIf="!bannerCBSAAverages?.cbsa && summaryData?.sqftProjectionStatus !== '--'" class="pdf-cell-sublabel">
                {{ 'SUMMARY_SECTION.RELATIVE_OVERALL_AVG' | translate }}
              </small>
              <small *ngIf="bannerCBSAAverages?.cbsa" class="pdf-cell-sublabel">
                {{ 'SUMMARY_SECTION.OUT_OF' | translate:{name: bannerCBSAAverages?.name, state: getStateAbbreviation(cbsaName)} }}
              </small>
            </div>
          </div>

          <!-- Second Row -->
          <div class="pdf-summary-row pdf-summary-row-last">
            <div class="pdf-summary-cell">
              <div class="pdf-cell-label">Closest {{ summaryData?.nearestStore?.bannerName || 'Store' }}</div>
              <div class="pdf-cell-value">{{ summaryData?.nearestStore?.distance ? (summaryData.nearestStore.distance | number:'1.2-2') + ' mi' : '--' }}</div>
            </div>
            <div class="pdf-summary-cell">
              <div class="pdf-cell-label">Closest Competitor</div>
              <div class="pdf-cell-value">{{ summaryData?.closetCompetitor?.storeName && summaryData?.closetCompetitor?.distance ? summaryData.closetCompetitor.storeName + ' - ' + (summaryData.closetCompetitor.distance | number:'1.2-2') + ' mi' : '--' }}</div>
            </div>
            <div class="pdf-summary-cell pdf-summary-cell-last">
              <div class="pdf-cell-label">Future openings</div>
              <div class="pdf-cell-value">Count within 7 mins / closest</div>
              <div class="pdf-cell-extra">{{ summaryData?.futureStoreCount || 0 }} / {{ summaryData?.nearestFutureStoreDistance ? (summaryData.nearestFutureStoreDistance | number:'1.2-2') + ' mi' : '0.00 mi' }} ({{ summaryData?.nearestFutureStoreName || '--' }})</div>
            </div>
          </div>
        </div>

        <!-- Map Image Placeholder -->
        <div class="pdf-map-placeholder">
          <div class="map-snapshot-container" id="map-snapshot-container">
            <div class="map-snapshot-placeholder" *ngIf="!mapSnapshotUrl">
              <span class="map-placeholder-text">Map Snapshot</span>
              <span class="map-placeholder-subtext">(Map image will be captured and inserted here)</span>
            </div>
            <img *ngIf="mapSnapshotUrl" [src]="mapSnapshotUrl" alt="Map Snapshot" class="map-snapshot-image" />
          </div>
        </div>
      </div>
    </div>

   <div class="competitive-pattern-line">
      <div class="pattern-segment"></div>
      <div class="pattern-segment"></div>
    </div>
  </div>
</div>

<div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-page-wrapper">
  <div id="pdf-page-2" class="pdf-page-competitive">
    <!-- Competitive Summary Section -->
    <div class="competitive-summary-container">
      <div class="competitive-summary-content">
        <!-- Header -->
        <div class="competitive-header">
          <div class="competitive-header-row">
            <div class="competitive-title">Competitive Summary</div>
            <div class="competitive-info">
              <div class="competitive-info-item">
                <span class="info-label">Est.</span>
                <span class="info-value"> {{ getCompetitiveEstLabel() }}</span>
              </div>
              <div class="competitive-info-item">
                <span class="info-value">{{ regionText }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="competitive-table">
          <!-- Table Header Row -->
          <div class="table-row table-header-row">
            <div class="table-cell table-cell-banner">
              <div class="cell-content">
                <div class="cell-text cell-text-bold">Banner</div>
              </div>
            </div>
            <div class="table-cell table-cell-sales">
              <div class="cell-content cell-content-center">
                <div class="cell-text cell-text-bold">{{ getCompetitiveColumnHeader() }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-count">
              <div class="cell-content cell-content-right">
                <div class="cell-text cell-text-bold">Count</div>
              </div>
            </div>
          </div>

          <!-- Data Rows -->
          <div class="table-row" *ngFor="let item of getCompetitiveDataForCurrentPage()">
            <div class="table-cell table-cell-banner">
              <div class="cell-content">
                <div class="cell-text">{{ item.banner || item.name }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-sales">
              <div class="cell-content cell-content-center">
                <div class="cell-text">{{ (item?.value ? item.value : '--') }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-count">
              <div class="cell-content cell-content-right">
                <div class="cell-text cell-text-inter">{{ item.count || item.totalCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="competitive-pattern-line">
      <div class="pattern-segment"></div>
      <div class="pattern-segment"></div>
    </div>
  </div>
</div>

<!-- Additional Competitive Pages -->
<div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-page-wrapper" *ngFor="let pageIndex of getAdditionalCompetitivePages(); let i = index">
  <div [id]="'pdf-page-competitive-' + (i + 1)" class="pdf-page-competitive">
    <!-- Competitive Summary Section -->
    <div class="competitive-summary-container">
      <div class="competitive-summary-content">
        <!-- Header -->
        <div class="competitive-header">
          <div class="competitive-header-row">
            <div class="competitive-title">Competitive Summary (Continued)</div>
            <div class="competitive-info">
              <div class="competitive-info-item">
                <span class="info-label">Est.</span>
                <span class="info-value"> {{ getCompetitiveEstLabel() }}</span>
              </div>
              <div class="competitive-info-item">
                <span class="info-value">{{ regionText }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="competitive-table">
          <!-- Table Header Row -->
          <div class="table-row table-header-row">
            <div class="table-cell table-cell-banner">
              <div class="cell-content">
                <div class="cell-text cell-text-bold">Banner</div>
              </div>
            </div>
            <div class="table-cell table-cell-sales">
              <div class="cell-content cell-content-center">
                <div class="cell-text cell-text-bold">{{ getCompetitiveColumnHeader() }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-count">
              <div class="cell-content cell-content-right">
                <div class="cell-text cell-text-bold">Count</div>
              </div>
            </div>
          </div>

          <!-- Data Rows -->
          <div class="table-row" *ngFor="let item of getCompetitiveDataForPage(pageIndex)">
            <div class="table-cell table-cell-banner">
              <div class="cell-content">
                <div class="cell-text">{{ item.banner || item.name }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-sales">
              <div class="cell-content cell-content-center">
                <div class="cell-text">{{ (item?.value ? item.value : '--') }}</div>
              </div>
            </div>
            <div class="table-cell table-cell-count">
              <div class="cell-content cell-content-right">
                <div class="cell-text cell-text-inter">{{ item.count || item.totalCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Decorative Pattern Line Bottom -->
    <div class="competitive-pattern-line">
      <div class="pattern-segment"></div>
      <div class="pattern-segment"></div>
    </div>
  </div>
</div>

<div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-page-wrapper" >
  <div id="pdf-page-3" class="pdf-second-page-container">
    <div class="content-wrapper">
      <div class="demographic-section">
        <div class="section-header-container">
          <div class="section-title">DEMOGRAPHIC PROFILE</div>
          <div>
            <span class="region-label">Current Region: </span>
            <span class="region-value">{{ regionText }}</span>
          </div>
        </div>
        <div class="section-description">
              This is a profile of the population in this store's local area. Consider this profile to be the first step towards understanding this store's target customer base, and how the local demographics may be affecting this store's performance.
            </div>
        <div class="demographic-content">
        <div class="ethnicity-header">
          <div class="ethnicity-title-col">
            <div class="demographic-title">ETHNICITY</div>
            <div class="demographic-divider"></div>
          </div>
          <div class="population-title-col">
            <div class="demographic-title">POPULATION</div>
            <div class="demographic-divider"></div>
          </div>
        </div>
        <div class="ethnicity-population-row">
          <div class="ethnicity-box">
            <div class="ethnicity-background"></div>
            <div class="ethnicity-breakdown">
              <div class="ethnicity-labels">
                <div class="ethnicity-label-other">Other</div>
                <div class="ethnicity-label">White</div>
                <div class="ethnicity-label">Asian</div>
                <div class="ethnicity-label">Black</div>
                <div class="ethnicity-label-hispanic">Hispanic</div>
              </div>
              <div class="ethnicity-values">
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.other }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.white }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.asian }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.black }}%</div>
                <div class="ethnicity-value-breakdown">{{ demographicData.ethnicity.hispanic }}%</div>
              </div>
            </div>
          </div>
          <div class="population-cards">
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <div class="population-card-icon population-card-icon-growth">
                  <img src="assets/images/Vector.png" style="width: 30.24px; height: 30.24px; left: 0.49px; top: 0.49px; position: absolute;">
                </div>
                <div class="population-card-label population-card-label-growth">Historical 2yr Growth</div>
              </div>
              <div class="population-card-value">{{ demographicData.population.growth2yr > 0 ? '+' : '' }}{{ demographicData.population.growth2yr }}%</div>
            </div>
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <img src="assets/images/Vector (1).png" class="population-card-icon-total" style="position: absolute;">
                <div class="population-card-label population-card-label-total">TOTAL POPULATION</div>
              </div>
              <div class="population-card-value">{{ demographicData.population.total | number }}</div>
            </div>
            <div class="population-card">
              <div class="population-card-content">
                <div class="population-card-bg"></div>
                <div class="population-card-label population-card-label-household">Projected 5yr Growth</div>
                <div class="population-card-icon population-card-icon-household">
                  <img src="assets/images/Vector (2).png" style="width: 28.01px; height: 21.01px; left: 0px; top: 3.50px; position: absolute;">
                </div>
              </div>
              <div class="population-card-value">{{ demographicData.population.householdGrowth2yr > 0 ? '+' : '' }}{{ demographicData.population.householdGrowth2yr }}%</div>
            </div>
          </div>
        </div>
        <div class="people-income-section">
          <div class="people-income-header">
            <div class="people-title-col">
              <div class="people-income-title">PEOPLE</div>
              <div class="demographic-divider"></div>
            </div>
            <div class="income-title-col">
              <div class="people-income-title">INCOME</div>
              <div class="demographic-divider"></div>
            </div>
          </div>
          <div class="people-income-cards">
            <div class="people-cards">
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-age">AVERAGE AGE</div>
                  <div class="population-card-icon" style="width: 28.31px; height: 28.31px; left: 24.51px; top: 23.51px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (3).png" style="width: 27.43px; height: 27.43px; left: 0.44px; top: 0.44px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ demographicData.people.averageAge | number:'1.1-1' }}</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-educated">COLLEGE EDUCATED</div>
                  <div class="population-card-icon" style="width: 38.02px; height: 30.41px; left: 19.42px; top: 25.51px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (4).png" style="width: 38.02px; height: 22.81px; left: 0px; top: 3.80px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ demographicData.people.educated }}%</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="people-card-bg"></div>
                  <div class="people-card-label people-card-label-household">HOUSEHOLD SIZE</div>
                  <div class="population-card-icon" style="width: 30.84px; height: 27.41px; left: 22.84px; top: 24.01px; position: absolute; overflow: hidden;">
                    <img src="assets/images/Vector (5).png" style="width: 30.84px; height: 23.98px; left: 0px; top: 1.72px; position: absolute;">
                  </div>
                </div>
                <div class="population-card-value">{{ demographicData.people.householdSize | number:'1.1-1' }}</div>
              </div>
            </div>
            <div class="income-cards">
              <div class="population-card">
                <div class="population-card-content">
                  <div class="income-card-bg"></div>
                  <div class="income-card-label income-card-label-average">AVERAGE INCOME</div>
                  <img src="assets/images/Vector (8).png" style="width: 17px; height: 31px; left: 26px; top: 19px; position: absolute;">
                  <img src="assets/images/Vector (6).png" style="width: 14px; height: 11px; left: 35px; top: 33px; position: absolute;">
                </div>
                <div class="population-card-value">{{ demographicData.income.average | number }}</div>
              </div>
              <div class="population-card">
                <div class="population-card-content">
                  <div class="income-card-bg"></div>
                  <div class="income-card-label income-card-label-median">MEDIAN INCOME</div>
                  <img src="assets/images/Vector (8).png" style="width: 17px; height: 31px; left: 26px; top: 19px; position: absolute;">
                  <img src="assets/images/Vector (7).png" style="width: 14px; height: 11px; left: 35px; top: 33px; position: absolute;">
                </div>
                <div class="population-card-value">{{ demographicData.income.median | number }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="data-provider">
        <div class="data-provider-text">Demographic data provided by Synerpos Technologies, Inc.</div>
      </div>

      <div class="logo-container">
      <div class="image">
        <img src="assets/images/RetailStat_2023_Icon_RGB 1.png"/>
      </div>
      <div class="logo-text1">Powered by&nbsp;<span style="color: #853694;">Retailstat</span>&nbsp;All Rights Reserved</div>
      <!-- <div class="logo-text2"></div> -->
        

      </div>

    </div>
      <div class="competitive-pattern-line">
      <div class="pattern-segment"></div>
      <div class="pattern-segment"></div>
    </div>

  </div>
</div>
